
const backendBookartUrl = 'https://bookart-np.elsevier.com/api/'
const FaqVideoDev = "https://d8z20visq58cz.cloudfront.net/Elsevier_chennai.mp4"
const allbooksFinalVideo = "https://d2j1sql5sv2ueu.cloudfront.net/All+Books+-+Final.mp4"
const instantOrderVideo = "https://d2j1sql5sv2ueu.cloudfront.net/Instant+order+-+Final.mp4"
const orderHistoryVideo = "https://d2j1sql5sv2ueu.cloudfront.net/Order+History+-+Final.mp4"
const supportPageVideo = "https://d2j1sql5sv2ueu.cloudfront.net/Support+page+-+Final.mp4"
export {backendBookartUrl, allbooksFinalVideo, instantOrderVideo, orderHistoryVideo, supportPageVideo }
